import React from 'react';
import { VerifyCodeForm } from './components/VerifyCodeForm';
import { VerificationGrid } from './styles';
import { VerificationWrapperDialog } from 'components/views/verification/components/VerificationWrapperDialog';
import {
  APIResponse,
  TwilioVerificationChannelEnum,
  User,
  TwilioCheckCodeCreateAccountValues,
} from '@alluradirect/react';
import { SendCodeFormWrapper } from 'components/views/verification/components/SendCodeFormWrapper';

export enum VerificationStepEnum {
  SendCode = 1,
  VerifyCode = 2,
}

interface Props {
  initialData: string;
  isOpen: boolean;
  userId?: number;
  initialStep?: VerificationStepEnum;
  channel: TwilioVerificationChannelEnum.sms | TwilioVerificationChannelEnum.email;
  handleClose: () => void;
  onVerifySuccess?: (data: APIResponse<{ USER: User }>) => void;
  createAccountData?: Pick<TwilioCheckCodeCreateAccountValues, 'first_name' | 'last_name' | 'password'>;
  /** Only works when verifying emails since they are unique, phone numbers are not */
  autoLoginOnVerificationSuccess?: boolean;
}

export const VerificationDialog = ({
  initialData,
  isOpen,
  userId,
  channel,
  initialStep = VerificationStepEnum.SendCode,
  handleClose,
  onVerifySuccess,
  createAccountData,
  autoLoginOnVerificationSuccess = false,
}: Props) => {
  const [step, setStep] = React.useState<VerificationStepEnum>(initialStep);
  const [data, setData] = React.useState(initialData);

  return (
    <VerificationWrapperDialog title={'Phone Verification'} isOpen={isOpen} close={handleClose}>
      <VerificationGrid container spacing={2}>
        {step === VerificationStepEnum.SendCode ? (
          <SendCodeFormWrapper
            data={data}
            channel={channel}
            setStep={setStep}
            handleCloseDialog={handleClose}
            setData={setData}
          />
        ) : null}

        {step === VerificationStepEnum.VerifyCode ? (
          <VerifyCodeForm
            data={data}
            initialStep={initialStep}
            handleCloseDialog={handleClose}
            setStep={setStep}
            channel={channel}
            onVerifySuccess={onVerifySuccess}
            userId={userId}
            createAccountData={createAccountData}
            autoLoginOnVerificationSuccess={autoLoginOnVerificationSuccess}
          />
        ) : null}
      </VerificationGrid>
    </VerificationWrapperDialog>
  );
};
